module.exports = __webpack_public_path__ + "static/media/3282305-394x394.049db190.jpg";